import LoadingImg from "../../Media/loading.gif";
const Loading = ()=>{
    return (
        <div className="common-bg">
            <div className="lodding">
                <div className="lodding-text">
                    <img src={LoadingImg} alt="Loading..." />
                </div>
            </div>
        </div>
    )
}
export default Loading;